// extracted by mini-css-extract-plugin
export default {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","large":"only screen and (min-width: 992px)","headerWrap":"Cn5sL","title":"oFn6M KJsah"};